import StyledButton from '../../components/Button/Button';
import {
    StyledSection,
    StyledContainer,
    StyledTitle,
    StyledSubtitle,
    StyledCounterSection,
} from './styles';
import { Box, BoxProps } from '@chakra-ui/react';
import CounterItem from '../../components/CounterItem/CounterItem';
import { buttonVariant } from '../../types/buttonTypes';

export interface CounterSectionProps extends BoxProps {
    data: string;
    title: string;
    subtitle: string;
    items: {
        mainNumber: string;
        additionalText: string;
        text: string;
    }[];
    buttons?: {
        title: string;
        href: string;
        variant: buttonVariant;
    }[];
    layout: '2x3' | '1x4';
}

const CounterSection: React.FC<CounterSectionProps> = ({
    title,
    subtitle,
    items,
    buttons,
    layout,
    ...rest
}) => {
    return (
        <Box {...rest}>
            <StyledSection>
                <StyledContainer $flex="column">
                    <StyledTitle>{title}</StyledTitle>
                    <StyledSubtitle $style="normal">{subtitle}</StyledSubtitle>
                </StyledContainer>
                <StyledCounterSection $layout={layout}>
                    {items.map(item => {
                        return (
                            <CounterItem
                                mainNumber={item.mainNumber}
                                additionalText={item.additionalText}
                                text={item.text}
                            />
                        );
                    })}
                </StyledCounterSection>

                {buttons?.length && (
                    <StyledContainer $flex="row">
                        {buttons?.map(button => {
                            return (
                                <StyledButton
                                    href={button.href}
                                    style={button.variant}
                                    target="_blank"
                                >
                                    {button.title}
                                </StyledButton>
                            );
                        })}
                    </StyledContainer>
                )}
            </StyledSection>
        </Box>
    );
};

export default CounterSection;
